<mat-card class="mat-elevation-z1">
    <p class="text-center">Veja abaixo a quantidade dos seus atendimentos semanais:</p>
    <page-bar-chart [itens]="chartItens"></page-bar-chart>    
</mat-card>
